<template>
    <CTable
            v-if="data.page"
            :isLoading="isLoading"
            v-model:columns="data.columns"
            v-model:page="data.page"
            :options="data.tableOptions"
            :manages="data.manages"
            :manageExtras="data.manageExtras"
            :rowActions="data.rowActions"
            :clientSide="true"
            :canRefresh="false"
            :visibleSearch="false"
            :visiblePagination="visiblePagination"
    ></CTable>
    <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm.validateInfos[itemsKey]?.help }}
        </div>
    </div>
    <CardBorder :title="$t('views.request.samplingAnalysisInfo.result')" class="mt-4">
        <ReleaseResultInfoForm
                :menuContext="menuContext"
                :viewOnly="viewOnly"
                :dataProp="data"
                dataKey="refSamplingAnalysisTemp"
                modelName="samplingAnalysis"
                :isLoading="isLoading"
        ></ReleaseResultInfoForm>
    </CardBorder>
    <div v-if="data.page" class="mt-4">
        <template v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)" :key="record.id || record._id">
            <CardBorder :title="$t('views.request.informProduct.record', { seq: index + 1 })">
                <TemplateBuilder
                        :rowProp="data.rowProp"
                        :useForm="data.useForm"
                        :fields="
                        createField({
                            props,
                            data,
                            key: `${itemsKey}.${index}`,
                            items: lodash.get(data.useForm.modelRef, itemsKey),
                            initItems: lodash.get(data.useForm.initialModel, itemsKey),
                            isLoading
                        })
                    "
                        :skeleton="isLoading"
                ></TemplateBuilder>
            </CardBorder>
        </template>
    </div>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../../../../app.logic";
    import { initData, isLoading } from "./sampling-analysis-product-info.logic";
    import { createField } from "./sampling-analysis-product-info.section";
    import lodash from "lodash";

    export default defineComponent({
        components: {
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../../components/input/template-builder/TemplateBuilder")),
            CTable: defineAsyncComponent(() => import("../../../../../../components/table/CTable")),
            CardBorder: defineAsyncComponent(() => import("../../../../../../components/card/CardBorder")),
            ReleaseResultInfoForm: defineAsyncComponent(() => import("../../../release/request/release-result-info/ReleaseResultInfoForm")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: {},
            dataProp: {},
            itemsKey: {},
            fetchCriteria: {},
            canCreate: {},
            canDelete: {},
            visiblePagination: { default: true },
        },
        setup(props) {
            const data = reactive({ ...props.dataProp });
            const refs = reactive({});
            initData({ props, data, refs })
            return { props, data, refs, isLoading, lodash, createField };
        }
    });
</script>